<div style="padding:20px"> 
    <ul class="nav nav-tabs" style="margin: 10px;">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item" (click)="choose(item.id)">
            <a onclick="return false;" [ngClass]="now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</a>
        </li>
    </ul>
    
    <hr>
    
    <app-table-v2 [type]="1"  [data]="data"  [tcontent]="tcontent">
        <ng-template let-post #operation_dk>
            <div>
                <div *ngIf="post.key == 'detail'"> 
                    <a href="javascript:void(0);" title="觀看詳細" (click)="viewAll(post.val)" data-toggle="modal" data-target="#staticBackdrop">
                        <i class="fa fa-list" aria-hidden="true"></i>
                    </a>
                </div>
            </div>
        </ng-template> 
    </app-table-v2>

    <!-- <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation>  -->
    <div *ngIf="data.length==0">無資料</div>
</div>

<app-spinner [loading]="loading"></app-spinner>

<!-- Modal -->
<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="staticBackdropLabel">推播紀錄</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <app-table-v2 [type]="1"  [data]="datadetail"  [tcontent]="tcontent2">
                    <ng-template let-post #operation_dk>
                        <div>
                            <div *ngIf="post.key == 'name'"> 
                                <app-userandactive  [post]="post.val"></app-userandactive>
                            </div>
                        </div>
                        <div>
                            <div *ngIf="post.key == 'img'"> 
                                <img loading="lazy" *ngIf="post.val.img.length>0" style="height:100px" [src]="post.val.img">
                                <span *ngIf="post.val.img.length==0">無附圖</span>
                            </div>
                        </div>
                    </ng-template>               
                </app-table-v2>        
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">關閉</button>
            </div>
        </div>
    </div>
</div>